import { createContext } from "react";

/** Mints a one-hour storefront preview token from the signed-in session. */
export const StorefrontPreviewTokenContext = createContext<
  (() => Promise<string>) | undefined
>(undefined);
StorefrontPreviewTokenContext.displayName = "StorefrontPreviewTokenContext";
